import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[injectComp]',
    standalone: false
})
export class InjectComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
